import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { ConfigurationFile } from 'containers/misc'
import { Account } from 'components/forms'
import { Checkbox } from 'components/fields'
import { Title, Button, FormDebug, Note } from 'components/misc'
import { wizard, meta } from 'helpers/decorators'
import { apiAwardUnits, apiConfiguration } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS } from 'constants/enums'
import validate from './award-unit-account.validation'
import styles from '../../awardUnit/AwardUnitAccount/award-unit-account.styl'

const enhance = compose(
  connect(({ api }) => ({
    configuration: api.configuration
  })),
  apiAwardUnits(),
  apiConfiguration(),
  wizard({
    form: 'awardUnitRegistration',
    multipage: true,
    destroyOnUnmount: false,
    validate
  }),
  meta({
    title: 'Online Record Book account',
    intlKey: 'moduleTitle.online_record_book_account'
  })
)

class AwardUnitAccount extends Component {
  static propTypes = {
    handleAwardUnitCreate: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onGetConfigurationValue: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    awardUnits: PropTypes.object,
    configuration: PropTypes.object,
    values: PropTypes.object,
    errors: PropTypes.object
  }

  componentDidMount = async () => {
    const { values } = this.props
    const organizationId =
      get(values, 'subOperatingAuthorityId') ||
      get(values, 'operatingAuthorityId') ||
      get(values, 'organizationId') ||
      get(values, 'naoId') ||
      1

    const response = await this.props.onGetConfigurationValue(
      CONFIGURATION_KEYS.auCoConduct.id,
      organizationId,
      true
    )

    const hasConductEnabled = get(response, 'body.booleanValue', false)

    if (hasConductEnabled) {
      await this.props.onGetConfigurationValue(
        CONFIGURATION_KEYS.auCoConductDoc.id,
        organizationId,
        true
      )
    }

    const naoRegRequirementCfg = await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.enableNaoRegRequirements.id, organizationId, true)

    const isNaoRegRequirementEnabled = get(naoRegRequirementCfg, 'body.booleanValue', false)

    if (isNaoRegRequirementEnabled) {
      await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.naoRegRequirementsUrl.id, organizationId, true)
    }

    const privacyPolicyAgreementCfg = await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id, organizationId, true)

    const isPrivacyPolicyAgreementEnabled = get(privacyPolicyAgreementCfg, 'body.booleanValue', false)

    if (isPrivacyPolicyAgreementEnabled) {
      await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.privacyPolicyUrl.id, organizationId, true)
    }
  }

  handleSubmit = fields => {
    this.props
      .handleAwardUnitCreate(fields)
      .then(() => {
        this.props.onSubmit()
        this.props.reset()
      })
      .catch(err => console.log(err))
  }

  render() {
    const {
      handleSubmit,
      values,
      errors,
      awardUnits,
      configuration
    } = this.props

    const organizationId =
      get(values, 'subOperatingAuthorityId') ||
      get(values, 'operatingAuthorityId') ||
      get(values, 'organizationId') ||
      get(values, 'naoId') ||
      1

    const hasConductEnabled = get(configuration, `values[${CONFIGURATION_KEYS.auCoConduct.id}].booleanValue`)
    const conductUrl = get(configuration, `values[${CONFIGURATION_KEYS.auCoConductDoc.id}].fileUrl`)

    const isNaoRegRequirementEnabled = get(configuration, `values[${CONFIGURATION_KEYS.enableNaoRegRequirements.id}].booleanValue`)
    const naoRegRequirementUrl = get(configuration, `values[${CONFIGURATION_KEYS.naoRegRequirementsUrl.id}].textValue`)

    const isPrivacyPolicyAgreementEnabled = get(configuration, `values[${CONFIGURATION_KEYS.enablePrivacyPolicyAgreement.id}].booleanValue`)
    const privacyPolicyUrl = get(configuration, `values[${CONFIGURATION_KEYS.privacyPolicyUrl.id}].textValue`)


    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.online_record_book_account"
            defaultMessage="Online Record Book account"
          />
        </Title>

        <Note margin="-15px 0 30px">
          <FormattedMessage
            id="label.to_work_on_the_online"
            defaultMessage="To work on the Online Record Book (ORB) you need a personal ORB record"
          />
        </Note>

        <Account values={values} prefix="awardLeaderRegistration" />

        <div className="row">
          <div className="col-xs-12">
            <div style={{ float: 'left' }}>
              <Checkbox
                name="helpers.terms"
                label="I have read the <a href='{url}' target='_blank'>Terms and conditions</a> and agree with them."
                intlKey="label.i_have_read_the_terms_and_conditions"
                intlValues={{
                  url: '/orb_parental_consent_form.pdf'
                }}
              />
            </div>
            <div style={{ float: 'left', marginTop: 1, marginLeft: 5 }}>
              <ConfigurationFile
                configKey={CONFIGURATION_KEYS.termsAndConditionsUnit.id}
                organizationId={organizationId}
                isPublic
                formattedName={
                  <FormattedMessage
                    id="button.terms_and_conditions"
                    defaultMessage="International Terms & Conditions"
                  />
                }
              />
            </div>
            <div style={{ clear: 'both' }}></div>

            <div className={styles.agreementsWrapper}>
            {hasConductEnabled &&
              conductUrl &&
              <Checkbox
                name="helpers.agreementCodeOfConduct"
                label="I Agree to Volunteer Code of Conduct."
                intlKey="label.i_agree_to_volunteer_code"
                intlValues={{
                  url: conductUrl
                }}
              />}

            {!get(values, 'isIacRegistration') &&
            isNaoRegRequirementEnabled &&
            naoRegRequirementUrl &&
            <Checkbox
              name="helpers.naa"
              label="I confirm that I meet all NAA Regulation Requirements. <a href='{url}' target='_blank'>For more information click here.</a>"
              intlKey="label.i_confirm_that_i_meet"
              intlValues={{
                url: naoRegRequirementUrl
              }}
            />}

            {isPrivacyPolicyAgreementEnabled &&
            privacyPolicyUrl &&
            <Checkbox
              name="helpers.agreementPrivacyPolicy"
              label="I have read the Privacy Policy and agree with. <a href='{url}' target='_blank'>The Privacy Policy is here.</a>"
              intlKey="label.i_agree_to_privacy_policy"
              intlValues={{
                url: privacyPolicyUrl
              }}
            />}
            </div>
          </div>
        </div>

        <FormDebug values={values} errors={errors} />

        <Button disabled={get(awardUnits, 'loading')}>
          <FormattedMessage id="button.finish" defaultMessage="Finish" />
        </Button>
      </form>
    )
  }
}

export default enhance(AwardUnitAccount)
